export const PLAYER_STATUS_CATEGORY = {
  FINISHED: 'FINISHED',
  STARTED: 'STARTED',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED'
};

export const PLAYER_STATUS = {
  STARTED: 'UPLOAD_STARTED',
  FAILED: 'FAILED',
  WAITING: 'WAITING_FILE',
  PROCESSING: 'PROCESSING',
  TRANSCODE_READY: 'READY_ON_TRANSCODE',
  PARTIALLY_READY: 'PARTIALLY_READY',
  QUEUED: 'QUEUED',
  FINISHED: 'READY',
  UPLOAD_FINISHED: 'UPLOAD_FINISHED',
  THUMBNAIL_READY: 'THUMBNAIL_READY',
  THUMBNAIL_FAILED: 'THUMBNAIL_FAILED',
  NONE: 'NONE'
};

export const PLAYER_STATUS_CATEGORIES = {
  THUMBNAIL_FINISHED: [
    PLAYER_STATUS.FINISHED,
    PLAYER_STATUS.THUMBNAIL_READY,
    PLAYER_STATUS.THUMBNAIL_FAILED
  ],
  THUMBNAIL_DONE: [PLAYER_STATUS.THUMBNAIL_READY, PLAYER_STATUS.FINISHED],
  FINISHED: [
    PLAYER_STATUS.FINISHED,
    PLAYER_STATUS.PARTIALLY_READY,
    PLAYER_STATUS.THUMBNAIL_READY,
    PLAYER_STATUS.THUMBNAIL_FAILED
  ],
  STARTED: [PLAYER_STATUS.STARTED],
  PROCESSING: [
    PLAYER_STATUS.WAITING,
    PLAYER_STATUS.TRANSCODE_READY,
    PLAYER_STATUS.PROCESSING,
    PLAYER_STATUS.QUEUED,
    PLAYER_STATUS.UPLOAD_FINISHED
  ],
  FAILED: [PLAYER_STATUS.FAILED]
};

const { FINISHED, THUMBNAIL_FINISHED, PROCESSING } = PLAYER_STATUS_CATEGORIES;

export const FINISHED_PLAYER_ATTACHMENT = FINISHED.concat(
  THUMBNAIL_FINISHED,
  PROCESSING
);
